import axiosInstance from '../config/AxiosIntance'

function getSkills() {
  return axiosInstance('/skills')
}

export default getSkills
